import React from 'react';
import { SignInForm } from './forms/SignInForm';
import { AuthWrapper } from '../../../_uiComponents/common/AuthWrapper';

export function SignInWrapper(props) {

    return (
        <>
         <AuthWrapper heading="Login">
            <SignInForm />
         </AuthWrapper> 
        </>
    )
}
